/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface EmailFormState {
  status: 'idle' | 'loading' | 'success' | 'error';
  email: string | null;
  isOtpSent: boolean;
  isOtpResent: boolean;
  error: {
    isError: boolean,
    type: string | null,
    message: string | null
  }
}

// Initial State
const initialState: EmailFormState = {
  status: 'idle',
  email: null,
  isOtpSent: false,
  isOtpResent: false,
  error: {
    isError: false,
    type: null,
    message: '',
  },
};

// Slice
export const emailFormSlice = createSlice({
  name: 'emailForm',
  initialState,
  reducers: {
    addEmail: (state, action) => {},
    verifyEmail: (state, action) => {},
    setEmail: (state, action) => {
      state.email = action.payload.email;
      state.isOtpSent = true;
      state.status = 'success';
      state.isOtpResent = true;
    },
    resendEmailOtp: (state, action) => {},
    setResendEmailOtp: (state, action) => {
    },
    setOtpSentStatus: (state, action) => {
      state.isOtpSent = action.payload.isOtpSent;
    },
    setIsEmailOtpResent: (state, action) => {
      state.isOtpResent = action.payload;
    },
    setEmailFormError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    setEmailFormStatus: (state, action) => {
      state.status = action.payload;
    },
    clearEmailFormError: (state) => {
      state.error = {
        isError: false,
        type: null,
        message: '',
      };
      state.status = 'idle';
    },
    clearEmail: (state, action) => {
      state.email = action.payload.null;
    },
  },
});

// Actions
export const {
  addEmail, verifyEmail, setEmail, clearEmail, setOtpSentStatus,
  setEmailFormError, setEmailFormStatus, clearEmailFormError, setIsEmailOtpResent, resendEmailOtp, setResendEmailOtp,
} = emailFormSlice.actions;

// Slice Reducer
export default emailFormSlice.reducer;
